import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { SettingsPaths } from "Pages/settings/paths";

import { ComplianceSettingsPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const ContactRestrictionsPage = lazy(() => import("./Pages/ContactRestrictionsPage/ContactRestrictionsPage"));
const HolidaysPage = lazy(() => import("./Pages/HolidaysPage/HolidaysPage"));
const CallLimitsPage = lazy(() => import("./Pages/CallLimitsPage/CallLimitsPage"));
const StateOfEmergencyPage = lazy(() => import("./Pages/StateOfEmergencyPage/StateOfEmergencyPage"));

export const complianceSettingsRoute: RegalRouteObject = {
    path: `${SettingsPaths.complianceSettings}/*`,
    element: <RVRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: (
                <Navigate
                    to={`${AppPagePaths.settings}/${SettingsPaths.complianceSettings}/${ComplianceSettingsPaths.contactRestrictions}`}
                    replace
                />
            ),
        },
        {
            path: ComplianceSettingsPaths.contactRestrictions,
            element: <ContactRestrictionsPage />,
        },
        {
            path: ComplianceSettingsPaths.holidays,
            element: <HolidaysPage />,
        },
        {
            path: ComplianceSettingsPaths.callLimits,
            element: <CallLimitsPage />,
        },
        {
            path: ComplianceSettingsPaths.stateOfEmergency,
            element: <StateOfEmergencyPage />,
        },
    ],
};
